/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Mv = __webpack_require__(310);
	
	var _Mv2 = _interopRequireDefault(_Mv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.addEventListener('load', function () {
	  setTimeout(function () {
	    new _Mv2.default();
	  }, 600);
	});

/***/ },

/***/ 300:
/***/ function(module, exports) {

	/*!
	 * Library.coffee - JavaScript Plugin
	 *
	 * Version  : 4.1 (2017/02/01)
	 *
	 * CopyRight (c) library.js Naotaka Kawakami.
	 * Dual licensed under the MIT licenses.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var Library = function () {
		var Library = {};
	
		Library.Visitor = function (IMAGES, CALL) {
			var floatFormat = function floatFormat(number, n) {
				return Math.round(parseFloat(number) * Math.pow(10, n)) / Math.pow(10, n);
			};
	
			var _ua = window.navigator.userAgent.toLowerCase();
			var _av = window.navigator.appVersion.toLowerCase();
	
			var data = {
				userAgent: _ua,
				type: undefined,
				browser: { app: undefined, version: undefined },
				device: { os: undefined, version: undefined }
			};
	
			var arr;
			if (_ua.indexOf("windows") !== -1 && _ua.indexOf("touch") !== -1 && _ua.indexOf("tablet pc") === -1) {
				data.type = 'tablet';
				data.device.os = 'windows tablet';
			} else if (_ua.indexOf('windows phone') !== -1) {
				arr = /windows phone\ ([\d\.]+)/.exec(_ua);
				data.type = 'mobile';
				data.device.os = 'windows phone';
				data.device.version = floatFormat(arr[1], 1);
			} else if (_ua.indexOf("ipad") !== -1) {
				arr = /os (\w+){1,3}/g.exec(_ua);
				data.type = 'tablet';
				data.device.os = 'ios';
				data.device.version = floatFormat(arr[1].replace(/_/g, '.'), 1);
			} else if (_ua.indexOf("iphone") !== -1 || _ua.indexOf("ipod") !== -1) {
				if (_ua.indexOf("opera") !== -1) {
					data.device.version = undefined;
				} else {
					arr = /iphone os (\w+){1,3}/g.exec(_ua);
					data.device.version = floatFormat(arr[1].replace(/_/g, '.'), 1);
				}
				data.type = 'mobile';
				data.device.os = 'ios';
			} else if (_ua.indexOf("android") !== -1 && _ua.indexOf("mobile") !== -1) {
				arr = /android\ ([\d\.]+)/.exec(_ua);
				data.type = 'mobile';
				data.device.os = 'android';
				data.device.version = floatFormat(arr[1], 1);
			} else if (_ua.indexOf("android") !== -1) {
				arr = /android\ ([\d\.]+)/.exec(_ua);
				data.type = 'tablet';
				data.device.os = 'android';
				data.device.version = floatFormat(arr[1], 1);
			} else if (_ua.indexOf("bb10") !== -1 || _ua.indexOf("blackberry") !== -1) {
				data.type = 'mobile';
				data.device.os = 'blackberry';
				if (_ua.indexOf("bb10") !== -1) {
					data.device.version = 'bb10';
				} else {
					arr = /blackberry\ ([\d\.]+)/.exec(_ua);
					data.device.version = arr[1];
				}
			} else if (_ua.indexOf("playbook") !== -1) {
				data.type = 'tablet';
				data.device.os = 'blackberry';
				data.device.version = 'playbook';
			} else if (_ua.indexOf("windows") !== -1) {
				arr = /windows nt\ ([\d\.]+)/.exec(_ua);
				data.type = 'pc';
				data.device.os = 'windows';
				if (arr[1] === '10.0') {
					data.device.version = 10;
				} else if (arr[1] === '6.3') {
					data.device.version = 8.1;
				} else if (arr[1] === '6.2') {
					data.device.version = 8;
				} else if (arr[1] === '6.1') {
					data.device.version = 7;
				} else if (arr[1] === '6.0') {
					data.device.version = 'vista';
				} else if (arr[1] === '5.2') {
					data.device.version = 'xp';
				} else if (arr[1] === '5.1') {
					data.device.version = 'xp';
				}
			} else if (_ua.indexOf("macintosh") !== -1) {
				arr = /mac os x\ ([\d\.]+)/.exec(_ua);
				data.type = 'pc';
				data.device.os = 'mac';
				data.device.version = parseFloat(arr[1]);
			}
	
			if (_ua.indexOf('msie') >= 0 || _ua.indexOf('trident') >= 0) {
				arr = /(msie|rv:?)\s?([\d\.]+)/.exec(_ua);
				data.browser.app = 'ie';
				data.browser.version = arr ? parseFloat(arr[2]) : undefined;
			} else {
				if (_ua.indexOf('edge') !== -1) {
					arr = /edge\/([\d\.]+)/.exec(_ua);
					data.browser.app = 'edge';
				} else if (_ua.indexOf('firefox') !== -1 || _ua.indexOf('fxios') !== -1) {
					arr = _ua.indexOf('firefox') !== -1 ? /firefox\/([\d\.]+)/.exec(_ua) : /fxios\/([\d\.]+)/.exec(_ua);
					data.browser.app = 'firefox';
				} else if (_ua.indexOf('opera') !== -1 && _ua.indexOf("version") !== -1 || _ua.indexOf("opr") !== -1) {
					arr = _ua.indexOf("version") !== -1 ? /version\/([\d\.]+)/.exec(_ua) : /opr\/([\d\.]+)/.exec(_ua);
					data.browser.app = 'opera';
				} else if (_ua.indexOf('chrome') !== -1 || _ua.indexOf('crios') !== -1) {
					arr = _ua.indexOf('chrome') !== -1 ? /chrome\/([\d\.]+)/.exec(_ua) : /crios\/([\d\.]+)/.exec(_ua);
					data.browser.app = 'chrome';
				} else if (_ua.indexOf("bb10") !== -1 || _ua.indexOf("blackberry") !== -1 || _ua.indexOf("playbook") !== -1) {
					arr = _ua.indexOf("blackberry") !== -1 ? /blackberry\ ([\d\.]+)/.exec(_ua) : undefined;
					data.browser.app = 'blackberry';
				} else if (_ua.indexOf('android') !== -1 && _ua.indexOf("mobile") !== -1) {
					arr = /android\ ([\d\.]+)/.exec(_ua);
					data.browser.app = 'android';
				} else if (_ua.indexOf('safari') !== -1 && _ua.indexOf("version") !== -1) {
					arr = /version\/([\d\.]+)/.exec(_ua);
					data.browser.app = 'safari';
				}
				data.browser.version = arr ? parseFloat(arr[1]) : undefined;
			}
	
			return data;
		};
	
		// よく使うのでプロパティにしとく
		Library.isPc = /^\/sp\//.test(location.pathname) ? false : true;
		Library.isOldIos = Library.Visitor().device.os === 'ios' && Library.Visitor().device.version <= 8 ? true : false;
		Library.isOldAndroid = Library.Visitor().device.os === 'android' && Library.Visitor().device.version <= 4.4 ? true : false;
	
		return Library;
	}();
	
	exports.default = Library;

/***/ },

/***/ 303:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Library = __webpack_require__(300);
	
	var _Library2 = _interopRequireDefault(_Library);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CONSTANT = {
	  FPS: 60,
	  FORCE_BASE: 60,
	  SCROLL: {
	    AREA: 150, // エリア上下の余白
	    PADDING: _Library2.default.isPc ? 150 : 300,
	    WAIT: 140 // スクロール完了とみなすms
	  },
	  DATA: {
	    FORCE: 'force',
	    TYPE: 'type',
	    SLANT: 'slant'
	  },
	  CLASSNAME: {
	    SCROLL: 'js-scroll',
	    TRANSITION: 'can-transit',
	    ACTIVE: 'is-active',
	    VISIBLE: 'is-visible',
	    LEAVE: 'is-leave',
	    SCROLLING: 'is-scrolling',
	    FRICTION: 'has-force',
	    ILLUST: 'has-force',
	    SPEEDY: 'is-speedy'
	  },
	  BEZIER: {
	    ACTION: {
	      IN: 'fadein',
	      IUT: 'fadeout'
	    }
	  }
	};
	
	CONSTANT.FRAME_TIME = 1000 / CONSTANT.FPS;
	
	exports.default = CONSTANT;

/***/ },

/***/ 304:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constant = __webpack_require__(303);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _ScrollHandler = __webpack_require__(305);
	
	var _ScrollHandler2 = _interopRequireDefault(_ScrollHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Utility = function () {
	  function Utility() {
	    _classCallCheck(this, Utility);
	  }
	
	  _createClass(Utility, null, [{
	    key: 'getUnixTime',
	    value: function getUnixTime() {
	      return new Date().getTime();
	    }
	  }, {
	    key: 'getRandomRange',
	    value: function getRandomRange(min, max) {
	      return Math.random() * (max - min) + min;
	    }
	  }, {
	    key: 'setStyleToElements',
	    value: function setStyleToElements(elements, styles) {
	      var _loop = function _loop(i, length) {
	        Object.keys(styles).forEach(function (key) {
	          elements[i].style[key] = styles[key];
	        });
	      };
	
	      for (var i = 0, length = elements.length; i < length; i++) {
	        _loop(i, length);
	      }
	    }
	  }, {
	    key: 'translateXY',
	    value: function translateXY(element, x, y) {
	      var t = 'translate3d(' + x + 'px, ' + y + 'px, 0)';
	      var s = element.style;
	
	      s['transform'] = t;
	      s['webkitTransform'] = t;
	    }
	  }, {
	    key: 'scale',
	    value: function scale(element, x, y) {
	      var t = 'scale(' + x + ', ' + y + ')';
	      var s = element.style;
	
	      s['transform'] = t;
	      s['webkitTransform'] = t;
	    }
	
	    // https://github.com/jquery/jquery/blob/bf3a43eff8682b59cec785be6003753fa4b93706/src/offset.js
	
	  }, {
	    key: 'getElementTop',
	    value: function getElementTop(elm) {
	      return elm.getBoundingClientRect().top + window.pageYOffset;
	    }
	  }, {
	    key: 'getElementCenter',
	    value: function getElementCenter(elm) {
	      return this.getElementTop(elm) + elm.clientHeight / 2;
	    }
	  }, {
	    key: 'getElementBottom',
	    value: function getElementBottom(elm) {
	      return this.getElementTop(elm) + elm.clientHeight;
	    }
	  }, {
	    key: 'inArea',
	    value: function inArea(windowTop, windowBottom, elementTop, elementBottom) {
	      if (elementTop <= windowBottom && elementBottom >= windowTop) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'isPassed',
	    value: function isPassed(windowBottom, elementTop) {
	      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	      if (windowBottom >= elementTop + offset) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'getRandomFloat',
	    value: function getRandomFloat(min, max) {
	      return Math.random() * (max - min) + min;
	    }
	  }]);
	
	  return Utility;
	}();
	
	exports.default = Utility;

/***/ },

/***/ 305:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constant = __webpack_require__(303);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _Utility = __webpack_require__(304);
	
	var _Utility2 = _interopRequireDefault(_Utility);
	
	var _Library = __webpack_require__(300);
	
	var _Library2 = _interopRequireDefault(_Library);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScrollHandler = function () {
	  function ScrollHandler() {
	    _classCallCheck(this, ScrollHandler);
	  }
	
	  _createClass(ScrollHandler, [{
	    key: 'init',
	    value: function init() {
	      this.elm = {
	        container: document.getElementById('container'),
	        contents: document.getElementById('contents')
	      };
	
	      this.instances = [];
	      this.lastCalledTime = _Utility2.default.getUnixTime();
	      this.targetY = 0;
	      this.scrolling = false;
	      this.pageScrolling = false;
	      this.pageScollDuration = 1400;
	      this.keyScrollHeight = 800;
	      this.timer = {
	        scroll: null
	      };
	      this.stay = false;
	    }
	  }, {
	    key: 'addInstances',
	    value: function addInstances() {
	      var _instances;
	
	      (_instances = this.instances).push.apply(_instances, arguments);
	    }
	  }, {
	    key: 'bindScroll',
	    value: function bindScroll() {
	      var _this = this;
	
	      window.addEventListener('scroll', function (e) {
	        _this.targetY = -pageYOffset;
	        _this.run();
	      });
	    }
	  }, {
	    key: 'triggerScroll',
	    value: function triggerScroll(force) {
	      if (force || this.elm.container.getAttribute('data-trigger-scroll')) {
	        this.run();
	      }
	    }
	  }, {
	    key: 'run',
	    value: function run() {
	      var _this2 = this;
	
	      var windowTop = -this.targetY;
	      var windowBottom = windowTop + window.innerHeight - _constant2.default.SCROLL.PADDING;
	
	      clearTimeout(this.timer.scroll);
	      this.timer.scroll = setTimeout(function () {
	        _this2.callInstanceMethod('onScrollEnd', windowTop, windowBottom);
	      }, _constant2.default.SCROLL.WAIT);
	
	      setTimeout(function () {
	        return _this2.callInstanceMethod('onScrollStart', windowTop, windowBottom);
	      }, 1);
	    }
	  }, {
	    key: 'callInstanceMethod',
	    value: function callInstanceMethod(methodName) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      this.instances.forEach(function (instance) {
	        return instance[methodName].apply(instance, args);
	      });
	    }
	  }]);
	
	  return ScrollHandler;
	}();
	
	// export as singleton
	
	
	exports.default = new ScrollHandler();

/***/ },

/***/ 310:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constant = __webpack_require__(303);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	var _Utility = __webpack_require__(304);
	
	var _Utility2 = _interopRequireDefault(_Utility);
	
	var _Library = __webpack_require__(300);
	
	var _Library2 = _interopRequireDefault(_Library);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Mv = function () {
	  function Mv() {
	    _classCallCheck(this, Mv);
	
	    this.main();
	  }
	
	  _createClass(Mv, [{
	    key: 'main',
	    value: function main() {
	      document.getElementById('mv-title-left').classList.add(_constant2.default.CLASSNAME.ACTIVE);
	      document.getElementById('mv-title-right').classList.add(_constant2.default.CLASSNAME.ACTIVE);
	      setTimeout(function () {
	        document.getElementById('mv-illust').classList.add(_constant2.default.CLASSNAME.ACTIVE);
	      }, 2400);
	    }
	  }]);
	
	  return Mv;
	}();
	
	exports.default = Mv;

/***/ }

/******/ });


// WEBPACK FOOTER //
// assets/js/index.js